export const priceFormat = (price) => {
    var locPrice = price.toString()
    for(let i = 0; i < locPrice.length; i++)  {
        if(i % 4 == 3) {
            locPrice = locPrice.substring(0, locPrice.length - i) + ',' + locPrice.substring(locPrice.length - i, locPrice.length);
        }
    }
    return locPrice;
}